import React from 'react';

import { FallbackContainer, ErrorMessage, ReloadButton } from './styles';

const Fallback = () => (
  <FallbackContainer>
    <ErrorMessage>Something went wrong</ErrorMessage>
    <img src="https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg" alt="" />
    <ReloadButton type="button" onClick={() => window.location.reload()}>
      Reload page
    </ReloadButton>
  </FallbackContainer>
);

export default Fallback;
